import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["giver", "receiver", "button"]

  connect() {
    this.activeClasses = ["bg-blue-600", "text-white", "hover:bg-blue-700", "shadow-blue-200"];
    this.inactiveClasses = ["bg-slate-100", "text-slate-400", "cursor-not-allowed", "shadow-none"];
    this.validate();
  }

  validate() {
    const giverId = this.giverTarget.value;
    const receiverId = this.receiverTarget.value;

    const isValid = giverId && receiverId && giverId !== receiverId;
    this.buttonTarget.disabled = !isValid;
    this.buttonTarget.classList.remove(...this.activeClasses, ...this.inactiveClasses);
    this.buttonTarget.classList.add(...(isValid ? this.activeClasses : this.inactiveClasses));
  }
}
